import React, { useState } from "react";
import { IconCaretDownFilled } from "@tabler/icons-react";
import { Link, useLocation } from "react-router-dom";

function NavDropdownModal({ handleNavItemClick, handleBookDemoClick, currentLanguage, closeMenu }) {
  const [showProductsOptions, setShowProductsOptions] = useState(false);
  const [showIndustriesOptions, setShowIndustriesOptions] = useState(false);
  const [showCompanyOptions, setShowCompanyOptions] = useState(false);

  const location = useLocation();

  const toggleOptions = (option) => {
    switch (option) {
      case "products":
        setShowProductsOptions(!showProductsOptions);
        setShowIndustriesOptions(false);
        setShowCompanyOptions(false);
        break;
      case "industries":
        setShowProductsOptions(false);
        setShowIndustriesOptions(!showIndustriesOptions);
        setShowCompanyOptions(false);
        break;
      case "company":
        setShowProductsOptions(false);
        setShowIndustriesOptions(false);
        setShowCompanyOptions(!showCompanyOptions);
        break;
      default:
        break;
    }
  };

  const closeAllDropdowns = () => {
    setShowProductsOptions(false);
    setShowIndustriesOptions(false);
    setShowCompanyOptions(false);
  };

  const handleEnterPress = (path) => {
    closeAllDropdowns();
    handleNavItemClick(path);
  };


  return (
    <div className="dropdown-nav-container">
      <div>
        <div
          className="dropdown-nav-option-wrapper"
          onClick={() => toggleOptions("products")}
          // onFocus={() => toggleOptions("products")}
          tabIndex={0}
        >
          <div className="nav-item-container">
            <span>
              {
                {
                  en: "Solutions",
                  fr: "Solutions",
                  de: "Lösungen",
                  es: "Soluciones"
                }[currentLanguage]
              }
            </span>
          </div>
          <div className="caret-wrapper">
            <IconCaretDownFilled
              size={20}
              className={`caret ${showProductsOptions ? "active" : ""}`}
            />
          </div>
        </div>
        {showProductsOptions && (
          <div className="dropdown-nav-more-options">
            <Link
              to="/tram"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/tram" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/tram");
                }
              }}
              tabIndex={0}
            >
              <span>TRAM</span>
              <p>
                {
                  {
                    en: "Training Records & Asset Management Solution",
                    fr: "Solution de gestion des enregistrements de formation et des actifs",
                    de: "Schulungsverwaltung und Anlagenmanagement",
                    es: "Solución de gestión de registros de formación y activos"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/deams"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/deams" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/deams");
                }
              }}
              tabIndex={0}
            >
              <span>DEAMS</span>
              <p>
                {
                  {
                    en: "Digital Evidence & Asset Management Solution",
                    fr: "Solution de gestion des preuves numériques et des actifs",
                    de: "digitale Beweismittelverwaltung und Digital Asset Management",
                    es: "Solución de gestión de evidencia digital y activos"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/dytask"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/dytask" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/dytask");
                }
              }}
              tabIndex={0}
            >
              <span>DyTASK</span>
              <p>
                {
                  {
                    en: "GIS for Policing, with demand prediction and effective patrol and tasking management",
                    fr: "SIG pour la police, avec prévision de la demande et gestion efficace des patrouilles et des tâches",
                    de: "GIS für die Polizei mit Bedarfsprognose, Streifenplanung und Aufgabenmanagement",
                    es: "GIS para la policía, con predicción de demanda y gestión eficaz de patrullas y tareas"
                  }[currentLanguage]
                }
              </p>
            </Link>
          </div>
        )}
        <div
          className="dropdown-nav-option-wrapper"
          onClick={() => toggleOptions("industries")}
          // onFocus={() => toggleOptions("products")}
          tabIndex={0}
        >
          <div className="nav-item-container">
            <span>
              {
                {
                  en: "Industries",
                  fr: "Industrie",
                  de: "Branchen",
                  es: "Industria"
                }[currentLanguage]
              }
            </span>
          </div>
          <div className="caret-wrapper">
            <IconCaretDownFilled
              size={20}
              className={`caret ${showIndustriesOptions ? "active" : ""}`}
            />
          </div>
        </div>
        {showIndustriesOptions && (
          <div className="dropdown-nav-more-options">
            <Link
              to="/police"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/police" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/police");
                }
              }}
              tabIndex={0}
            >
              <p>
                {
                  {
                    en: "Police",
                    fr: "Police",
                    de: "Polizei",
                    es: "Policía"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/fire"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/fie" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/fire");
                }
              }}
              tabIndex={0}
            >
              <p>
                {
                  {
                    en: "Fire & Rescue",
                    fr: "Services d’Incendie et Secours",
                    de: "Feuerwehr & Rettungsdienst",
                    es: "Servicios de bomberos y rescate"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/government"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/government" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/government");
                }
              }}
              tabIndex={0}
            >
              <p>
                {
                  {
                    en: "Government & University",
                    fr: "Gouvernement et Universités - Recherche",
                    de: "Behörden & Universitäten",
                    es: "Gobierno y Universidades - Investigación"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/education"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/education" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/education");
                }
              }}
              tabIndex={0}
            >
              <p>
                {
                  {
                    en: "Education",
                    fr: "Éducation",
                    de: "Universitäten",
                    es: "Educación"
                  }[currentLanguage]
                }
              </p>
            </Link>
            <Link
              to="/aviation"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/aviation" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/aviation");
                }
              }}
              tabIndex={0} 
            >
              <p>
                {
                  {
                    en: "Aviation",
                    fr: "Aviation",
                    de: "Luftfahrt",
                    es: "Aviación"
                  }[currentLanguage]
                }
              </p>
            </Link>
          </div>
        )}
        <div
          className="dropdown-nav-option-wrapper"
          onClick={() => toggleOptions("company")}
          // onFocus={() => toggleOptions("company")}
          tabIndex={0}
        >
          <div className="nav-item-container">
            <span>
              {
                {
                  en: "Company",
                  fr: "Compagnie",
                  de: "Unternehmen",
                  es: "Compañía"
                }[currentLanguage]
              }
            </span>
          </div>
          <div className="caret-wrapper">
            <IconCaretDownFilled
              size={20}
              className={`caret ${showCompanyOptions ? "active" : ""}`}
            />
          </div>
        </div>
        {showCompanyOptions && (
          <div className="dropdown-nav-more-options">
            <Link
              to="/about"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/about" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/about");
                }
              }}
              tabIndex={0}
            >
              {
                {
                  en: "About",
                  fr: "À propos",
                  de: "Über uns",
                  es: "Acerca de"
                }[currentLanguage]
              }
            </Link>
            <Link
              to="/resources"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/resources" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/resources");
                }
              }}
              tabIndex={0}
            >
              {
                {
                  en: "Resources",
                  fr: "Ressources",
                  de: "Ressourcen",
                  es: "Recursos"
                }[currentLanguage]
              }
            </Link>
            <Link
              to="/careers"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/careers" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/careers");
                }
              }}
              tabIndex={0}
            >
              {
                {
                  en: "Join",
                  fr: "Rejoindre",
                  de: "Stellenangebote",
                  es: "Unirse"
                }[currentLanguage]
              }
            </Link>
            <Link
              to="/contact"
              onClick={() => closeMenu()}
              className={`dropdown-item ${
                location.pathname === "/contact" ? "active-dropdown-item" : ""
              }`}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleEnterPress("/contact");
                }
              }}
              tabIndex={0}
            >
              {
                {
                  en: "Contact",
                  fr: "Contact",
                  de: "Kontakt",
                  es: "Contacto"
                }[currentLanguage]
              }
            </Link>
          </div>
        )}
      </div>
      <div className="dropdown-button-container">
        <button className="cta-button-dropdown" onClick={handleBookDemoClick}>
          {
            {
              en: "Request a demo",
              fr: "Réserver une démo",
              de: "Demo anfordern",
              es: "Solicitar una demo",
            }[currentLanguage]
          }
        </button>
      </div>
    </div>
  );
}

export default NavDropdownModal;
